import React from 'react';
import PropTypes from 'prop-types';
import { getVehicleLiveOfferStatusStyle } from '../common/helpers/auctionColorHelper';
import { AuctionStatus, AuctionStatusName } from '../constants/AuctionStatus';
import lightningGreenIcon from '../assets/img/icons/lightning_green_icon.svg';

function AuctionStatusBox({ auction, content, customBoxVariant }) {
  return (
    <div
      className={`auction-status-box status-box box-${
        customBoxVariant || getVehicleLiveOfferStatusStyle(auction?.status)
      } w-100 m-0 mb-3 d-flex justify-content-center align-items-center font-weight-bold `}
    >
      {auction?.status === AuctionStatus.PUBLISHED && (
        <img src={lightningGreenIcon} alt="Lightning icon" />
      )}
      <span>{content || AuctionStatusName[auction?.status] || ''}</span>
    </div>
  );
}

AuctionStatusBox.defaultProps = {
  content: '',
  customBoxVariant: null,
};

AuctionStatusBox.propTypes = {
  auction: PropTypes.object.isRequired,
  content: PropTypes.string,
  customBoxVariant: PropTypes.string,
};

export default AuctionStatusBox;
